import { FlatTreeControl } from "@angular/cdk/tree"
import { Component } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatTreeFlatDataSource, MatTreeFlattener } from "@angular/material/tree"
import { ActivatedRoute } from "@angular/router"
import { routes } from "../../../consts"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TREE_DATA: any = [
  {
    name: "Auctions",
    expanded: false,
    children: [
      {
        name: "Active",
        route: routes.AUCTION,
        active: "active"
      },
      {
        name: "All",
        route: routes.AUCTIONS_ALL,
        active: "active"
      }
    ],
    icon: "gavel"
  }
]

/** Flat node with expandable and level information */
interface RouteNode {
  expandable: boolean
  name: string
  level: number
  children?: RouteNode[]
}

@Component({
    selector: "app-client-sidebar",
    templateUrl: "./client-sidebar.component.html",
    styleUrls: ["./client-sidebar.component.scss"],
    standalone: false
})
export class ClientSidebarComponent {
  public routes: typeof routes = routes
  public isOpenUiElements = false

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      level,
      ...node
    }
  }

  treeFlattener = new MatTreeFlattener<RouteNode, RouteNode>(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  )

  treeControl = new FlatTreeControl<RouteNode>(
    (node) => node.level,
    (node) => node.expandable
  )

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener)

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute
  ) {
    this.dataSource.data = TREE_DATA
  }

  hasChild = (_: number, node: RouteNode) => node.expandable
}
